<script lang="ts">
  export let className: string = '';
  export let noiseImage: string = '';
  export let opacity: string = '0.3';
  export let size: string = '80px';
  export let blurBackground: boolean = true;
</script>

{#if blurBackground}
  <div class="noise--blur" />
{/if}
<div
  style:background-image="url('{noiseImage}')"
  class="noise {className}"
  style:--noise-opacity={opacity ?? '0.3'}
  style:--noise-size={size}
/>

<style lang="scss">
  @layer custom-components {
    .noise,
    .noise--blur {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    .noise--blur {
      backdrop-filter: blur(10px);
    }
    .noise {
      background-repeat: repeat;
      background-size: var(--noise-size);
      mix-blend-mode: overlay;
      opacity: var(--noise-opacity);
    }
  }
</style>
